/**
 * Brücke zwischen den Horizon-Blöcken und dem Dawn-basierten Theme.
 *
 * 1) Header-Höhen: Horizon-Blöcke (Hero-Höhe, Sticky-Produktdetails) erwarten die CSS-Variablen
 *    --header-height und --header-group-height. Diese werden hier aus dem Dawn-Header berechnet.
 *
 * 2) Warenkorb:
 * Horizon meldet ein erfolgreiches "In den Warenkorb" mit dem Event "cart:update".
 * Hier wird daraufhin der bestehende Dawn-Warenkorb (Benachrichtigung, Drawer oder Warenkorbseite)
 * genau so aktualisiert, wie es das Dawn-Theme bei eigenen Produktformularen tut.
 */
const SOURCES = new Set(['product-form-component']);

async function updateDawnCart(item) {
  const cartType = (window.Theme && Theme.dawnCartType) || 'notification';

  if (cartType === 'page') {
    window.location = (window.routes && window.routes.cart_url) || '/cart';
    return;
  }

  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

  if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') {
    // Fallback: zumindest den Warenkorb-Zähler im Header aktualisieren
    await refreshCartBubble();
    return;
  }

  const sectionIds = [...new Set(cart.getSectionsToRender().map((section) => section.id))];
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const response = await fetch(`${root}?sections=${sectionIds.join(',')}`);
  const sections = await response.json();

  if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
  cart.renderContents({ ...item, key: item.key, id: item.variant_id || item.id, sections });

  // publish/PUB_SUB_EVENTS sind globale Konstanten aus pubsub.js/constants.js (Dawn)
  if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: 'product-form',
      productVariantId: item.variant_id || item.id,
      cartData: item,
    });
  }
}

async function refreshCartBubble() {
  const bubble = document.getElementById('cart-icon-bubble');
  if (!bubble) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const response = await fetch(`${root}?sections=cart-icon-bubble`);
  const sections = await response.json();
  const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
  const source = html.querySelector('.shopify-section') || html.body;
  bubble.innerHTML = source.innerHTML;
}

document.addEventListener('cart:update', (event) => {
  const data = event.detail && event.detail.data;
  if (!data || data.didError || !SOURCES.has(data.source) || !data.item) return;
  updateDawnCart(data.item).catch((error) => console.error('[hz-dawn-bridge]', error));
});

function updateHeaderHeights() {
  const groupSections = document.querySelectorAll('.shopify-section-group-header-group');
  let groupHeight = 0;
  groupSections.forEach((section) => {
    groupHeight += section.offsetHeight;
  });

  const stickyHeader = document.querySelector('sticky-header');
  const stickyType = stickyHeader ? stickyHeader.dataset.stickyType : 'none';
  const headerSection = document.querySelector('.section-header');
  const headerHeight =
    headerSection && (stickyType === 'always' || stickyType === 'reduce-logo-size') ? headerSection.offsetHeight : 0;

  document.body.style.setProperty('--header-group-height', `${Math.round(groupHeight)}px`);
  document.body.style.setProperty('--header-height', `${Math.round(headerHeight)}px`);
}

updateHeaderHeights();
window.addEventListener('resize', updateHeaderHeights, { passive: true });
if ('ResizeObserver' in window) {
  const header = document.querySelector('.section-header');
  if (header) new ResizeObserver(updateHeaderHeights).observe(header);
}
